<script setup lang="ts">
const prop = defineProps({
  errorMsg: {type: String, required: true}
})
</script>

<template>
  <q-tooltip class="tw-bg-red-700 tw-text-sm tw-max-w-[320px]">
    {{ errorMsg }}
  </q-tooltip>
</template>

<style scoped>

</style>
